export const FROZEN_BLOCKS = [];
//# sourceMappingURL=index.js.map